import React from 'react';
import { Col, Form, Row } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';

import messages from '../../assets/i18n'

export default function OriginCertificateListFilter() {

  const dispatch = useDispatch();

  const lang = useSelector(state => state.language.name);
  const filters = useSelector(state => state.idgf.filter);

  const pageMessages = messages[lang].originCertificatePage.filter;

  const setFilters = (newFilters) => {
    dispatch({
      type: 'SET_ORIGIN_CERTIFICATE_FILTER',
      payload: newFilters
    })
  };

  const onEnterFilter = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault()
      dispatch({
        type: 'GET_ORIGIN_CERTIFICATE_LIST',
        payload: {
            page: 1,
            filters: filters,
            cleanTable: true
        }
      })
    }
  }

  return (
    <Form className="px-3">
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.codigo}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.codigo}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, codigo: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.pedido}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.pedido}
                    type="text"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, pedido: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dtPedidoInicial}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dtPedidoInicial}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dtPedidoInicial: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dtPedidoFinal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dtPedidoFinal}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dtPedidoFinal: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dtAtualizacaoInicial}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dtAtualizacaoInicial}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dtAtualizacaoInicial: event.target.value },
                    )}
                />
        </Form.Group>
        <Form.Group as={Col} className="mt-1">
            <Form.Label className="text-2">{pageMessages.dtAtualizacaoFinal}</Form.Label>
                <Form.Control
                    className="text-2 border-radius-full"
                    placeholder={pageMessages.dtAtualizacaoFinal}
                    type="date"
                    defaultValue={''}
                    onKeyDown={onEnterFilter}
                    onChange={event => setFilters(
                        { ...filters, dtAtualizacaoFinal: event.target.value },
                    )}
                />
        </Form.Group>
      </Row>
    </Form>
  );
}
